"use client";

import * as Sentry from "@sentry/nextjs";
import { BookOpen } from "lucide-react";
import Link from "next/link";
import { useCallback, useEffect } from "react";

import { Button } from "@/components/ui/button";
import { SUPPORT_EMAIL } from "@/lib/constants";
import routes from "@/lib/routes";

export default function Error({
  error: error,
}: {
  error: Error & { digest?: string };
}) {
  const reload = useCallback(() => {
    window.location.reload();
  }, []);

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex flex-auto min-h-full items-center justify-center bg-background px-4">
      <div className="flex max-w-md flex-col items-center text-center">
        <h1 className="mb-4 text-3xl font-semibold text-foreground">
          Oops, that&apos;s our bad
        </h1>
        <p className="mb-8 text-muted-foreground">
          We&apos;re not exactly sure what happened, but something went wrong.
          If you need immediate help, please contact us at{" "}
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="underline hover:text-foreground"
          >
            {SUPPORT_EMAIL}
          </a>
        </p>

        <div className="flex gap-2">
          <Button onClick={reload} variant="default" className="min-w-32">
            Try again
          </Button>

          <Link href={routes.getJobs()}>
            <Button variant="outline" className="min-w-32">
              <BookOpen />
              Browse Jobs
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
